// extracted by mini-css-extract-plugin
export default {"loading":"success-page_loading__cWF-u"};